import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CostElementsModule } from '../cost-elements/cost-elements.module';
import { LayersModule } from '../layers/layers.module';
import { SharedModule } from '../shared/shared.module';
import { SimulationModule } from '../simulation/simulation-module';
import { ProjectFormComponent } from './project-form/project-form.component';
import { ProjectListMenuComponent } from './project-list-menu/project-list-menu.component';
import { ProjectListComponent } from './project-list/project-list.component';
import { ProjectMenuComponent } from './project-menu/project-menu.component';
import { ProjectComponent } from './project/project.component';
import { ProjectsComponent } from './projects.component';
import { ProjectFilterPipe } from './shared/pipe/project-filter.pipe';
import { ProjectSquareComponent } from './project-square/project-square.component';
import { ProjectUploadStatusComponent } from './project-upload-status/project-upload-status.component';

@NgModule({
  declarations: [
    ProjectListComponent,
    ProjectComponent,
    ProjectFormComponent,
    ProjectMenuComponent,
    ProjectListMenuComponent,
    ProjectsComponent,
    ProjectFilterPipe,
    ProjectSquareComponent,
    ProjectUploadStatusComponent
  ],
  exports: [ProjectListMenuComponent],
  imports: [
    RouterModule,
    CommonModule,
    SharedModule,
    LayersModule,
    SimulationModule,
    CostElementsModule
  ]
})
export class ProjectsModule { }
